export const isMobile = () => {
  const userAgent = navigator.userAgent;
  const isMobile = /Mobile|Android|iP(hone|od|ad)/.test(userAgent);

  return isMobile;
};
